import { publicNamespaceUid } from "../constants";
/**
 * Returns the path for resolving a static part version ref relative to its storage root, be it a GCS
 * bucket or an HTTP origin.
 */
export function relativePathForStaticPartVersionDescriptor(descriptor, namespaceUid = publicNamespaceUid) {
    return `${namespaceUid}/${descriptor.schemaTag}/${descriptor.partUid}/${descriptor.partVersion}.json`;
}
//# sourceMappingURL=staticRefPaths.js.map